
import React from 'react';
import { Info } from 'lucide-react';
import { 
  Tooltip, 
  TooltipContent, 
  TooltipProvider, 
  TooltipTrigger 
} from "@/components/ui/tooltip";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useIsMobile } from '@/hooks/use-mobile';

interface TooltipExplanationProps {
  text: string;
  explanation: string;
}

const TooltipExplanation: React.FC<TooltipExplanationProps> = ({ text, explanation }) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <button className="flex items-center gap-1 cursor-pointer">
            {text}
            <Info className="h-3 w-3 text-muted-foreground" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="max-w-xs">
          <p>{explanation}</p>
        </PopoverContent>
      </Popover>
    );
  }
  
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex items-center gap-1">
          {text}
          <Info className="h-3 w-3 text-muted-foreground cursor-help" />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <p>{explanation}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default TooltipExplanation;
